import { SelectionModel } from '@angular/cdk/collections';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Id } from '@core/http/crud-model';

@Component({
  selector: 'app-collective-checkbox',
  templateUrl: './collective-checkbox.component.html',
  styleUrls: ['./collective-checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollectiveCheckboxComponent implements OnInit, OnChanges, OnDestroy {
  @Input() selection: SelectionModel<Id>;
  @Input() collectiveCheckbox: FormControl;
  @Input() data: Required<{ id: Id }>[];
  private selectionChangeSubscription: Subscription;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.listenSelectionChanges();
    this.syncCollectiveCheckboxValue();
  }

  ngOnChanges(): void {
    this.syncCollectiveCheckboxValue();
  }

  ngOnDestroy(): void {
    this.selectionChangeSubscription?.unsubscribe();
  }

  get isCurrentPageFullySelected(): boolean {
    return this.data?.length > 0 && this.getSelectedItemsCount() === this.data.length;
  }

  get isCurrentPagePartiallySelected(): boolean {
    const selectedItemsCount = this.getSelectedItemsCount();
    return selectedItemsCount > 0 && selectedItemsCount < this.data?.length;
  }

  toggleCurrentPageSelection(checkbox: CheckboxView): void {
    if (this.isCurrentPagePartiallySelected || this.isCurrentPageFullySelected) {
      this.selection.deselect(...this.data.map((item: Required<{ id: Id }>) => item.id));
    } else {
      this.selection.select(...this.data.map((item: Required<{ id: Id }>) => item.id));
    }

    checkbox.checked = this.isCurrentPageFullySelected;
    checkbox.indeterminate = this.isCurrentPagePartiallySelected;
  }

  private listenSelectionChanges(): void {
    this.selectionChangeSubscription = this.selection.changed.subscribe(() => {
      this.syncCollectiveCheckboxValue();
      this.cdr.markForCheck();
    });
  }

  private getSelectedItemsCount(): number {
    return this.data?.filter((item: Required<{ id: Id }>) => this.selection.isSelected(item.id)).length ?? 0;
  }

  private syncCollectiveCheckboxValue(): void {
    this.collectiveCheckbox?.patchValue(this.isCurrentPageFullySelected, { emitEvent: false });
  }
}

interface CheckboxView {
  checked: boolean;
  indeterminate: boolean;
}
